// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"16":"smallProfileCard","136":"events","715":"teachers-list","939":"google-map"}[chunkId] + "." + {"16":"6a672f73","136":"7d813a23","715":"9d019734","939":"fc464c3e"}[chunkId] + ".css";
};